import bankAccountsReducer from "./bankAccountsReducer"
export default bankAccountsReducer